/**
 * Care Plan Service
 * Patient care plan management and tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetMeasureDto } from './targetMeasureDto';


export interface GoalDto { 
    /**
     * Goal description
     */
    description: string;
    /**
     * Target measure for goal tracking
     */
    targetMeasure?: TargetMeasureDto;
    /**
     * Goal status
     */
    status: GoalDto.StatusEnum;
}
export namespace GoalDto {
    export type StatusEnum = 'active' | 'achieved' | 'revised' | 'cancelled';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Achieved: 'achieved' as StatusEnum,
        Revised: 'revised' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum
    };
}


